import { Handle, Position } from "@xyflow/react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import "./ActivityFlow.css";

const FormSubmittedNode = ({ selected }) => {
  return (
    <div className={`custom_job_node ${selected ? "selected" : ""}`}>
      <div className="custom_job_node_content">
        <div className="custom_job_node_icon" style={{ color: "#4287f5" }}>
          <MaterialIcon name="assignment" style={{ fontSize: "40px", fontWeight: "500" }} />
        </div>
      </div>
      <div className="custom_job_node_label">Form Submitted</div>
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: "#764ba2" }}
        className="custom_handle_right"
      />
    </div>
  );
};

export default FormSubmittedNode;
